<template>
  <div
    ref="dropdownEl"
    class="hs-dropdown relative [--trigger:click]"
    :class="customClasses"
  >
    <span
      v-if="legendText && !isEmptyObj(selected) && title"
      class="bg-white text-grey-mid absolute translate-y-[-50%] left-[10px] text-[10px] uppercase text-ellipsis overflow-hidden max-w-[50%] whitespace-nowrap px-[4px] z-[11] hs-dropdown-open:z-[22]"
    >
      {{ title }}
    </span>
    <button
      id="hs-dropdown-default"
      type="button"
      class="bg-white hs-dropdown-toggle py-[9px] px-[11px] outline-0 flex justify-between w-full h-full items-center gap-2 rounded-[5px] border border-grey-pale text-[14px] relative z-[10] hs-dropdown-open:z-[20]"
      :class="{
        'text-blue hs-dropdown-open:bg-blue-15 font-bold': themeBlue,
        'font-light text-grey-mid': !themeBlue && isEmptyObj(selected),
        'font-normal !text-charcoal': !themeBlue && !isEmptyObj(selected),
        'sm:text-[20px] leading-[26px] tracking-[-0.2px]': large,
      }"
    >
      {{ isEmptyObj(selected) ? title : selected.text }}
      <InlineSvg
        src="/assets/svg/icons/chevron-down.svg"
        class="transition w-[16px] h-[8px] text-grey-mid"
      />
    </button>

    <div
      class="hs-dropdown-menu !mt-[-15px] transition-[opacity,margin] duration-[0.1ms] hs-dropdown-open:opacity-100 opacity-0 hidden bg-white border border-grey-pale rounded-lg p-2 rounded-t-none z-[12] hs-dropdown-open:z-[19] border-t-0 shadow-default"
      aria-labelledby="hs-dropdown-default"
    >
      <div
        class="grid gap-[2px]"
        :class="{
          'custom-blue-scrollbar max-h-[160px] overflow-auto pr-[5px]':
            !fullMenu,
        }"
      >
        <a
          v-for="(item, i) in dataFormat"
          :key="i"
          class="flex items-center gap-x-3.5 py-2 px-3 rounded-md text-[14px] font-medium"
          :class="{
            'bg-gray-100':
              !isEmptyObj(selected) &&
              selected.value == item.value &&
              !themeBlue,
            'bg-blue-25':
              !isEmptyObj(selected) &&
              selected.value == item.value &&
              themeBlue,
            'text-blue hover:bg-blue-15': themeBlue,
            'text-grey-mid hover:bg-gray-100': !themeBlue,
          }"
          href="#"
          @click="handleChange(item)"
        >
          {{ item.text }}
        </a>
      </div>
    </div>
  </div>
  <span
    v-for="err in errors"
    :key="err.$uid"
    class="text-red-alert block mt-[5px] text-[13px]"
  >
    {{ err.$message }}
  </span>
</template>
<script setup>
import { useHelpers } from '@/composables/useHelpers';
import { computed, onMounted, ref, watch } from 'vue';

const emit = defineEmits(['update:modelValue']);
const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: '',
  },
  customClasses: {
    type: String,
    default: '',
  },
  title: {
    type: String,
    default: '',
  },
  legendText: {
    type: Boolean,
    default: true,
  },
  large: {
    type: Boolean,
    default: false,
  },
  items: {
    type: Array,
    default: () => [],
  },
  errors: {
    type: Array,
    default: () => [],
  },
  textField: {
    type: [String, Object],
    default: 'name',
  },
  trackBy: {
    type: [String, Object],
    default: 'id',
  },
  fullMenu: {
    type: Boolean,
    default: false,
  },
  menuWidth: {
    type: Number,
    default: 0,
  },
  trigger: {
    type: String,
    default: 'click',
  },
  themeBlue: {
    type: Boolean,
    default: false,
  },
});
const { getValInObj, isEmptyObj } = useHelpers();
watch(
  () => props.modelValue,
  (newVal) => {
    setSelected(newVal);
  }
);

const dataFormat = computed(() => {
  const data = props.items.map((obj) => {
    if (typeof obj == 'object') {
      if (props.textField) obj.text = getValInObj(obj, props.textField);
      if (props.trackBy) obj.value = getValInObj(obj, props.trackBy);
    } else {
      obj = {
        text: obj,
        value: obj,
      };
    }
    return obj;
  });

  return data;
});

const selected = ref(null);
const setSelected = (val) =>
  (selected.value = dataFormat.value.find((i) => i.value == val));
setSelected(props.modelValue);

const handleChange = (item) => {
  selected.value = item;
  emit('update:modelValue', item.value);
};

const dropdownEl = ref(null);
onMounted(() => {
  dropdownEl.value.addEventListener('open.hs.dropdown', () => {
    const width =
      (props.menuWidth ? props.menuWidth : dropdownEl.value.clientWidth) + 'px';
    const menuEl = dropdownEl.value.querySelector('.hs-dropdown-menu');
    menuEl.style.width = width;
  });
});
</script>
